<template>
  <el-dialog
    class="modal-modify-type"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    custom-class="greater"
  >
    <div class="content">
      <h3 class="title">基本信息配置</h3>
      <el-form
        ref="modifyType1"
        label-position="top"
        label-width="80px"
        class="type-modify__form1"
        @submit.native.prevent
      >
        <el-form-item label="接口名称:" prop="apiName">
          <el-input
            :value="modalData.apiName"
            placeholder="必填"
            disabled
            style="width: 440px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="ActioName:" prop="actionName">
          <el-input disabled :value="modalData.actionName" placeholder="选填" style="width: 440px;"></el-input>
        </el-form-item>

        <el-form-item label="接口说明:" prop="description">
          <el-input
            type="textarea"
            style="width: 500px; height: 48px;"
            resize="none"
            maxlength="50"
            placeholder="选填, 可填入50个字符"
            disabled
            :value="modalData.description"
          ></el-input>
        </el-form-item>
      </el-form>

      <h3 class="title">接口字段对接</h3>
      <el-form
        ref="modifyType2"
        label-position="top"
        label-width="80px"
        class="type-modify__form2"
        @submit.native.prevent
      >
        <el-form-item>
          <el-tabs type="border-card" class="tabs">
            <el-tab-pane label="请求参数">
              <cd-transfer :keyList.sync="reqList"></cd-transfer>
            </el-tab-pane>
            <el-tab-pane label="返回参数">
              <cd-transfer :keyList.sync="resList"></cd-transfer>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button @click="$_cancle" class="cancel__btn">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import cdTransfer from "./transfer";

export default {
  name: "modal-modify-type",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "edit" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      reqList: [],
      resList: [],
      modal: {
        show: false,
        title: "",
        data: {}
      }
    };
  },
  methods: {
    // 保存
    $_submit() {
      const self = this;
      const portParamDockingInfoList = this.reqList.filter(item => item.systemDockingInfos.length).map(item => {
        const systemDockingInfos = item.systemDockingInfos.map(ele => {
          const {dockingFlowType, dockingSystemId} = ele
          return {
            dockingSystemId,
            dockingFlowType
          }
        })
        return {
          paramId: item.uid,
          systemDockingInfos
        }
      })
      const portResponseParamDockingInfoList = this.resList.filter(item => item.systemDockingInfos.length).map(item => {
        const systemDockingInfos = item.systemDockingInfos.map(ele => {
          const {dockingFlowType, dockingSystemId} = ele
          return {
            dockingSystemId,
            dockingFlowType
          }
        })
        return {
          paramId: item.uid,
          systemDockingInfos
        }
      })
      let postData = {
        pid: this.modalData.pid,
        portParamDockingInfoList: portParamDockingInfoList.length ? portParamDockingInfoList:null,
        portResponseParamDockingInfoList: portResponseParamDockingInfoList.length ? portResponseParamDockingInfoList:null
      };
      self.$service.post('portDockingInfoSave', postData).then(result => {
        if (result.$.checkResult(result, true)) {
          $MessageBox.alert({
            content: result.msg,
            onOk() {
              self.visible = false;
              self.$emit("callback");
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created(){
    this.reqList = this.modalData.portParamDockingInfoList.concat([])
    this.resList = this.modalData.portResponseParamDockingInfoList.concat([])
  },
  mounted() {
    this.visible = true;
  },
  components: {
    cdTransfer
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 12px;
  .title {
    padding-left: 20px;
    height: 32px;
    color: #3a3a3a;
    font-size: 14px;
    font-weight: 700;
  }
}
.type-modify__form1,.type-modify__form2 {
  padding-left: 20px;
}
/deep/ .transfer-wrapper .transfer__left{
width:460px
}
/deep/ .transfer-wrapper .transfer__right{
width:460px
}
/deep/ .input-tips{
  margin-left:10px;
}
/deep/ .el-table{
  background-color: rgb(245, 245, 245);
}

.tabs {
  position: relative;
  border: 1px solid #eee;
  /deep/ .el-tabs__header {
    background-color: #fff;
    padding: 0;
    position: relative;
    border-bottom: 1px solid #eee;
    .el-tabs__nav-wrap {
      overflow: hidden;
      margin-bottom: -1px;
      position: relative;
      padding-left: 16px;
    }
  }
  /deep/ .el-tabs__nav {
    float: left;
    position: relative;
    white-space: nowrap;
    transition: transform 0.3s;
    z-index: 2;
  }
  /deep/ .el-tabs__item {
    height: 40px;
    width: 120px;
    border-bottom: 2px solid transparent;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    list-style: none;
    font-size: 16px;
    font-weight: 500;
    color: #898989;
    position: relative;
    cursor: pointer;
    &.is-active {
      color: #384e8c;
      border-bottom-color: #384e8c;
    }
    &:focus,
    &:focus:active {
      outline: none;
    }
    &:nth-child(2) {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
  /deep/ .el-tab-pane {
    height: 100%;
  }
}
</style>
